/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ScreenshotsPublicRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getForProfileRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ScreenshotsPublicRpc',
  rpcName: 'getForProfile',
  auth: 'external',
  fingerprint: 'Xg3fwNX9y2HIXsgxxkXrL5wP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};